import { Grid } from "@mui/material";
import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  Button,
  Box,
  Link,
} from "@mui/material";

import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { UploadFile } from "@mui/icons-material";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
import AddNewPolicy from "../../../../Components/Broker/Policies/AddNewPolicy/AddNewPolicy";
import AddNewPolicyEmployer from "../../../../Components/Broker/Policies/AddNewPolicy/AddNewPolicyEmployer/AddNewPolicyEmployer";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import { useNavigate } from "react-router-dom";

export default function Policies() {
  const navigate = useNavigate();
  const [addCdBalance, setAddCdBalance] = React.useState(false);
  const [cdAmount, setCdAmount] = React.useState("");
  const [quotesArchiveListStatus, setQuotesArchiveListStatus] =
    React.useState("quotes");
  const [addFilterStatus, setAddFilterStatus] = React.useState(false);
  const [removeEmployee, setRemoveEmployee] = React.useState(false);
  const [removeEmployeeStep, setRemoveEmployeeStep] = React.useState(1);
  const [addNewEmployee, setAddNewEmployee] = React.useState(false);
  const [AddPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [addNewEmployeeStep, setAddNewEmployeeStep] = React.useState(1);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [uploadFileStep, setUploadFileStep] = React.useState(1);
  const [addPolicyEmployerStatus, setAddPolicyEmployerStatus] =
    React.useState(false);
  const [endorsementStatus, setEndorsementStatus] = React.useState(false);
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(new Date());
  const [oldValue, setOldValue] = React.useState<Date | null>(new Date());
  const [newValue, setNewValue] = React.useState<Date | null>(new Date());
  const [policyType, setPolicyType] = React.useState("");
  const [policyname, setPolicyName] = React.useState("");
  const [expiry, setExpiryStatus] = React.useState("");
  const [selectValue, setSelectValue] = React.useState("");
  const [oldsValue, setOldsValue] = React.useState("");
  const [newsValue, setNewsValue] = React.useState("");
  const [age, setAge] = React.useState("");
  const [gender, setGender] = React.useState("");
  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "gender") {
      setGender(event.target.value as string);
    } else if (attrName === "policyType") {
      setPolicyType(event.target.value as string);
    } else if (attrName === "expiry") {
      setExpiryStatus(event.target.value as string);
    } else if (attrName === "policyname") {
      setPolicyName(event.target.value as string);
    } else if (attrName === "age") {
      setAge(event.target.value as string);
    }
  };
  const cdAmount_data = [
    { label: "2L", value: "2L" },
    { label: "5L", value: "5L" },
    { label: "10L", value: "10L" },
    { label: "20L", value: "20L" },
    { label: "50L", value: "50L" },
  ];
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 2,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#2166AA" : "#308fe8",
    },
  }));

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "policy_id",
      headerName: "Policy ID",
      width: 170,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/PolicyDetail?product_type=" + row.policy_type);
            }}
          >
            EPZ08665R56456
          </Link>
        );
      },
    },
    {
      field: "client_name",
      headerName: "Client Name",
      width: 220,
      check_status: true,
    },
    {
      field: "client_id",
      headerName: "Client ID",
      width: 150,
      check_status: true,
    },
    {
      field: "policy_type",
      headerName: "Policy Type",
      width: 200,
      check_status: true,
    },
    {
      field: "insurer",
      headerName: "Insurer",
      width: 180,
      check_status: true,
    },
    {
      field: "policynumber",
      headerName: "Policy Number",
      width: 180,
      check_status: true,
    },
    {
      field: "start_date",
      headerName: "Policy Start Date",
      width: 130,
      check_status: true,
    },
    {
      field: "end_date",
      headerName: "Policy End Date",
      width: 130,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    {
      field: "nol",
      headerName: "No.of Lives",
      width: 100,
      check_status: true,
    },
    {
      field: "noe",
      headerName: "No. of Employees",
      width: 150,
      check_status: true,
    },
    {
      field: "sum_assured",
      headerName: "Sum Insured/Assured",
      width: 180,
      check_status: true,
    },
    {
      field: "cdbal",
      headerName: "CD Balance",
      width: 130,
      check_status: true,
    },
    {
      field: "premium",
      headerName: "Premium",
      width: 130,
      check_status: true,
    },
    {
      field: "branch_location",
      headerName: "Locations",
      width: 200,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 1,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Super Top-up Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 2,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 3,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 4,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 5,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 6,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 7,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 8,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹10,50,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 9,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
  ];

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };
  return (
    <Grid container spacing={3}>
      <Modal open={uploadFile} className="modalWrapper">
        <div>
          {uploadFileStep == 1 ? (
            <Box className="modalInner">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Link
                    className="close-button"
                    onClick={() => {
                      setUploadFile(false);
                    }}
                  />
                  <h5 className="popup-heading mb-4">Upload CSV</h5>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={0}
                justifyContent="center"
                className="mb-5"
              >
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Upload .xl .csv .xls file"
                    variant="outlined"
                    className="textarea"
                  />
                </Grid>
                <Grid item xs={2}>
                  <Button variant="contained" className="browsebtn">
                    Browse
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {
                      setUploadFileStep(2);
                    }}
                  >
                    Upload
                  </Button>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <h1></h1>
          )}
          {uploadFileStep == 2 ? (
            <Box className="modalInner">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Link
                    className="close-button"
                    onClick={() => {
                      setUploadFile(false);
                    }}
                  />
                  <h5 className="popup-heading">Uploading file</h5>
                </Grid>
              </Grid>
              <Grid container spacing={0}>
                <Grid item xs={12} className="mb-5">
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress variant="determinate" value={50} />
                  </Box>
                </Grid>
                <Grid item xs={12} className="mb-5">
                  <Link className="md-link" underline="none">
                    67%... donot close or switch tab while it’s uploading
                  </Link>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <h1></h1>
          )}
          {uploadFileStep == 3 ? (
            <Box className="modalInner">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Link
                    className="close-button"
                    onClick={() => {
                      setAddPolicyStatus(false);
                    }}
                  />
                  <h5 className="popup-heading">Kudos !!</h5>
                </Grid>
              </Grid>
              <Grid container spacing={0} textAlign="center">
                <Grid item xs={12} className="mb-5">
                  <h1>Img</h1>
                </Grid>
                <Grid item xs={12} className="mb-5">
                  <h5 className="popup-heading">You file has been uploaded</h5>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <h1></h1>
          )}
        </div>
      </Modal>
      <Modal open={addFilterStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddFilterStatus(false);
                }}
              />
              <h5 className="popup-heading">Add Filters</h5>
            </Grid>
          </Grid>
          <Grid container spacing={2} textAlign="center">
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Client ID</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Employee ID"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 lacs</MenuItem>
                  <MenuItem value={"22"}>22 lacs</MenuItem>
                  <MenuItem value={"24"}>24 lacs</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="Client Name"
                variant="outlined"
                className="textarea"
                sx={{ height: 120 }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Product</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Product"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Insurer</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Insurer"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Policy Number
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Policy Number"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">NOL</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="NOL"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  CD Balance
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="CD Balance"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Status"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="End Date"
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ textAlign: "center" }}
              className="ctaBtn"
            >
              <Button
                className="submitBtn"
                onClick={() => {
                  setAddFilterStatus(false);
                }}
              >
                Apply
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* Add New policy popup */}
      <AddNewPolicyEmployer
        open_status={addPolicyEmployerStatus}
        attrName={setAddPolicyEmployerStatus}
        value_update={updateMasterState}
      />
      {/* add cd balance popup */}
      <Modal open={addCdBalance} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid item xs={12} className="mb-5">
              <Link
                className="close-button"
                onClick={() => {
                  setAddCdBalance(false);
                }}
              />
              <h5 className="popup-heading">Add CD Balance</h5>
            </Grid>
          </Grid>
          {addNewEmployeeStep == 1 ? (
            <div>
              <Grid container spacing={2} justifyContent="center">
                <Grid xs={12} className="mb-5">
                  <SelectDropdown
                    class_name="inputField"
                    title="Enter CD Amount"
                    value={cdAmount}
                    attrName={setCdAmount}
                    value_update={updateMasterState}
                    dropdown_data={cdAmount_data}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center" }}
                  className="ctaBtn"
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => setAddCdBalance(false)}
                  >
                    Add Amount
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : null}
          {addNewEmployeeStep == 2 ? (
            <Grid item xs={12}>
              <Link className="md-link" underline="none">
                Great ! New Employee added.
              </Link>
            </Grid>
          ) : null}
        </Box>
      </Modal>
      <Grid item xs={6}>
        <h3 className="mb-0">Policies</h3>
      </Grid>
      <Grid item xs={6} className="text-right">
        {/* <Link
          
          underline="none"
          className="blackBtn settings"
          onClick={() => {
            setAddFilterStatus(true);
          }}
        >
          Filter
        </Link> */}
        {/* <Link
          
          underline="none"
          className="blueBtn docs"
          onClick={() => setUploadFile(true)}
        >
          CSV
        </Link>
        <Link
          
          underline="none"
          className="blueBtn docs"
          onClick={() => setAddCdBalance(true)}
        >
          Add CD Balance
        </Link>
        <Link
          
          underline="none"
          className="greenBtn addfile"
          onClick={() => {
            setAddPolicyEmployerStatus(true);
          }}
        >
          Add Policy
        </Link> */}
      </Grid>
      <Grid item xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
}
